import { createFileRoute, redirect } from '@tanstack/react-router'
import { NewPermitTemplateFormPage as PermitTemplateFormPage } from '@/features/city-clerk/permit-template'

export const Route = createFileRoute(
  '/(app)/city-clerk/$id/permit-template/new',
)({
  beforeLoad: ({ context }) => {
    if (context.auth.loading) return
    if (!context.auth.userInfo?.uiCapabilities?.permitTemplatesManage) {
      throw redirect({ to: '/access-denied' })
    }
  },
  component: PermitTemplateNewPage,
})

function PermitTemplateNewPage() {
  return <PermitTemplateFormPage mode="new" />
}
